import { useState } from 'react';
import { useIsomorphicLayoutEffect } from '@/hooks/chat/useIsomorphicLayoutEffect';
import { ChatWidget } from '@/components/ChatWidget';

// Wrapper per renderizzare ChatWidget solo client-side
export function ClientOnlyChatWidget() {
  const [isMounted, setIsMounted] = useState(false);

  useIsomorphicLayoutEffect(() => {
    setIsMounted(true);
  }, []);

  // Non renderizzare nulla durante SSR o prima del mount
  if (!isMounted) {
    return null;
  }

  return <ChatWidget />;
}
